import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from './actionTypes';
import { post, get } from "../../../helpers/api_helper";
import { getEmployeeExemptions } from './actions';
import Swal from 'sweetalert2';

function* getExemptionsSaga(action) {
  try {
    const formData = new FormData();
    formData.append("unit_id", action.payload?.unit_id);
    const response = yield call(post, process.env.REACT_APP_GET_EMPLOYEE_EXEMPTION, formData);
    yield put({ type: types.GET_EMPLOYEE_EXEMPTIONS_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: types.EMPLOYEE_EXEMPTION_FAILURE, payload: error });
  }
}

function* saveExemptionSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_SAVE_EMPLOYEE_EXEMPTION, action.payload);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to create exemption!");
    }

    Swal.fire({
      title: "Success",
      text: response?.message,
      icon: "success",
      confirmButtonText: "OK",
    });
    yield put({ type: types.SAVE_EMPLOYEE_EXEMPTION_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: types.EMPLOYEE_EXEMPTION_FAILURE, payload: error });
  }
}

function* changeStatusSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_UPDATE_EMPLOYEE_EXEMPTION_STATUS, action.payload);
    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to change status!");
    }
    Swal.fire({
      title: "Success",
      text: response?.message,
      icon: "success",
      confirmButtonText: "OK",
    });
    yield put({ type: types.CHANGE_EMPLOYEE_EXEMPTION_STATUS_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: types.EMPLOYEE_EXEMPTION_FAILURE, payload: error });
  }
}

export default function* employeeExemptionSaga() {
  yield takeLatest(types.GET_EMPLOYEE_EXEMPTIONS, getExemptionsSaga);
  yield takeLatest(types.SAVE_EMPLOYEE_EXEMPTION, saveExemptionSaga);
  yield takeLatest(types.CHANGE_EMPLOYEE_EXEMPTION_STATUS, changeStatusSaga);
}
